import React, { FC } from 'react';
import { useBrand, useTranslation } from '@edreamsodigeo/frontend-core';

const primeImageURL = ({
  brand,
  assetURL = '/images/onefront/bluestone',
  negative,
}) =>
  `${assetURL}/${brand === 'GO' ? 'GV' : brand}/prime_logo/logo-prime${
    negative ? `-negative-short` : ''
  }.svg`;

type PrimeLogoProps = {
  negative?: boolean;
  width?: string;
  height?: string;
};

const PrimeLogo: FC<PrimeLogoProps> = ({
  negative,
  width = 'auto',
  height = 'auto',
}) => {
  const brand = useBrand();
  const { t } = useTranslation();
  return (
    <img
      alt={t('prime.banner.small.description')}
      src={primeImageURL({ brand, negative })}
      width={width}
      height={height}
    />
  );
};

export default PrimeLogo;
